import { Injectable, inject } from '@angular/core'

import { sample } from 'effector'

import { BpmnEditorEffects } from '@flowx/designer/modules/bpmn-editor/store/bpmn-editor.effects'
import { NodeEffects } from '@flowx/designer/shared/effector/node/node.effects'
import { NodeEvents } from '@flowx/designer/shared/effector/node/node.events'
import { NodeStores } from '@flowx/designer/shared/effector/node/node.stores'
import { ProcessEffects } from '@flowx/designer/shared/effector/process/process.effects'
import { ProcessEvents } from '@flowx/designer/shared/effector/process/process.events'
import { SwimlaneEffects } from '@flowx/designer/shared/effector/swimlane/swimlane.effects'
import { SwimlaneEvents } from '@flowx/designer/shared/effector/swimlane/swimlane.events'
import { SwimlaneStores } from '@flowx/designer/shared/effector/swimlane/swimlane.stores'
import { SequenceEntity } from '@flowx/designer/shared/entities/sequence.entity'

import { BpmnEditorEvents } from './bpmn-editor.events'

import { ProcessEffector } from '../../../shared/effector/process.effector'

@Injectable({ providedIn: 'root' })
export class BpmnEditorSamples {
  private readonly bpmnEditorEffects = inject(BpmnEditorEffects)

  constructor() {
    sample({
      clock: ProcessEffector.sequencesLoaded,
      filter: ({ sequences }) => sequences.every((sequence) => sequence.layoutOptions !== null),
      target: ProcessEffector.sequencesWithLoadedLayoutOptions,
    })

    sample({
      clock: SwimlaneEffects.addSwimlaneFx.doneData,
      target: SwimlaneEvents.addedSwimlane,
    })

    sample({
      clock: this.bpmnEditorEffects.swimlaneRenameFx.doneData,
      target: SwimlaneEvents.swimlaneLabelEdited,
    })

    sample({
      clock: NodeEffects.deleteNodesFx.done,
      fn: ({ params }) => params.nodes,
      target: NodeEvents.deleteNodesDone,
    })

    /* TODO QuickFIx This is needed for sequence migration without layoutOptions */
    sample({
      source: {
        sequences: ProcessEffector.sequencesLoaded$,
        nodes: NodeStores.nodeDefinitions$,
        swimlanes: SwimlaneStores.swimlaneSummaries$,
        processesWithMigratedSequences: ProcessEffector.processesWithMigratedSequences$,
      },
      filter: ({ sequences, processesWithMigratedSequences, swimlanes }) =>
        !processesWithMigratedSequences.has(sequences?.processVersionId) &&
        Boolean(sequences) &&
        sequences.sequences.some(
          (sequence) => sequence.layoutOptions === null && swimlanes.size > 0
        ),
      fn: ({ nodes, sequences, swimlanes }) => ({
        processVersionId: sequences.processVersionId,
        sequences: SequenceEntity.migrateSequencesWithoutLayoutOptions(
          sequences.sequences,
          nodes,
          swimlanes
        ),
      }),
      target: ProcessEffector.sequencesWithMigratedLayoutOptions,
    })
    sample({
      clock: ProcessEffects.bulkUpdateProcessEntitiesFx.doneData,
      target: ProcessEvents.bulkUpdateProcessEntitiesDone,
    })

    sample({
      clock: BpmnEditorEvents.actionLoadingSuccess,
      filter: ({ withAi }) => !!withAi,
      fn: () => 'Business Rule',
      target: [
        BpmnEditorEvents.nodeActionChangeConfigTabActionHandler,
        BpmnEditorEvents.createBusinessRule,
      ],
    })
  }
}
